module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/point_02-448ef594a62e3f9159d1f4554a1a5135.png";